import React from 'react';
import Styled from 'styled';

import 'photoswipe/dist/default-skin/default-skin.css';
import defaultStyles, { DefaultUiStyles } from './default-ui.scss';
import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';

export interface Props {
    closeEl?: boolean;
    captionEl?: boolean;
    fullscreenEl?: boolean;
    zoomEl?: boolean;
    shareEl?: boolean;
    counterEl?: boolean;
    arrowEl?: boolean;
    preloaderEl?: boolean;
    arrowLeft?: string;
    arrowRight?: string;
    close?: string;
    fullscreen?: string;
    zoom?: string;
    share?: string;
    styles?: DefaultUiStyles;
    topBarBefore?: React.ReactNode;
    topBarAfter?: React.ReactNode;
    loading?: boolean;
}

class PhotoSwipeDefaultUI extends React.PureComponent<Props> {
    static defaultProps = {
        closeEl: true,
        captionEl: true,
        fullscreenEl: true,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
    };

    render() {
        const {
            styles,
            arrowLeft,
            arrowRight,
            fullscreen,
            zoom,
            share,
            close,
            topBarBefore,
            topBarAfter,
            children,
            loading,
        } = this.props;
        const { arrowEl, counterEl, closeEl, shareEl, fullscreenEl, zoomEl, preloaderEl, captionEl } = this.props;

        return (
            <div className={[styles!.ui, styles!.uiHidden].join(' ')}>
                <div className={styles!.topBar}>
                    <LoadingWrapperView loading={loading}>{topBarBefore}</LoadingWrapperView>
                    {counterEl ? <div className={styles!.counter} /> : null}
                    {closeEl ? <button className={styles!.buttonClose} title={close} /> : null}
                    {shareEl ? <button className={styles!.buttonShare} title={share} /> : null}
                    {fullscreenEl ? <button className={styles!.buttonFs} title={fullscreen} /> : null}
                    {zoomEl ? <button className={styles!.buttonZoom} title={zoom} /> : null}
                    {topBarAfter}
                    {preloaderEl ? (
                        <div className={styles!.preloader}>
                            <div className={styles!.preloaderIcn}>
                                <div className={styles!.preloaderCut}>
                                    <div className={styles!.preloaderDonut} />
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
                {shareEl ? (
                    <div className={[styles!.shareModal, styles!.shareModalHidden, styles!.singleTap].join(' ')}>
                        <div className={styles!.shareTooltip} />
                    </div>
                ) : null}
                {arrowEl ? (
                    <React.Fragment>
                        <button className={styles!.buttonArrowLeft} title={arrowLeft} />
                        <button className={styles!.buttonArrowRight} title={arrowRight} />
                    </React.Fragment>
                ) : null}
                {captionEl ? (
                    <div className={styles!.caption}>
                        <div className={styles!.captionCenter} />
                    </div>
                ) : null}
                {children}
            </div>
        );
    }
}

export default Styled(defaultStyles)(PhotoSwipeDefaultUI);
